export default __webpack_public_path__ + "static/media/7.1db97860.jpg";